export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 80,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('INDEX.table_label_image') || '图片',
    field: 'thumbImageUrl',
    width: 100,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    slots: { default: 'imageUrl' },
  },
  {
    title: that.$l('table_label_greyFabricName') || '坯布名称',
    field: 'greyFabricName',
    minWidth: 270,
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'greyFabricName' },
  },
  {
    title: that.$l('INDEX.Status') || '状态',
    field: 'userLoanRequestStatus',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'status' },
  },
  {
    title: that.$l('table_label_greyFabricWeight') || '颜色克重',
    field: 'greyFabricWeight',
    minWidth: 145,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'greyFabricWeight' },
  },

  {
    title: that.$l('table_label_greyFabricContent') || '坯布成分',
    field: 'greyFabricContent',
    minWidth: 270,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'greyFabricContent' },
  },
  {
    title: that.$l('table_label_greyFabricAgentName') || '业务开发',
    field: 'greyFabricAgentName',
    minWidth: 140,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_customerUse') || '使用客户',
    field: 'customerUse',
    minWidth: 140,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'customerUse' },
  },
  {
    title: that.$l('table_label_purchaseUnit') || '采购单价',
    field: 'purchaseUnit',
    minWidth: 130,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'purchaseUnit' },
  },
  {
    title: that.$l('table_label_scmName') || '工厂',
    field: 'scmName',
    minWidth: 240,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    width: 170,
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'createBy' },
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    width: 170,
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'modifyBy' },
  },
]
